import { render } from "./table-page.vue?vue&type=template&id=bc39f314"
import script from "./table-page.vue?vue&type=script&lang=js"
export * from "./table-page.vue?vue&type=script&lang=js"

import "./table-page.vue?vue&type=style&index=0&id=bc39f314&lang=less"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__